import { defineMessages } from 'react-intl';

export const title = defineMessages({
  ngeeann: {
    id: 'pages.about.ngeeann.title',
    defaultMessage: 'About Ngee Ann Polytechnic',
  },
  sginnovate: {
    id: 'pages.about.sginnovate.title',
    defaultMessage: 'About SGInnovate',
  },
  indorse: {
    id: 'pages.about.indorse.title',
    defaultMessage: 'About Indorse',
  },
});

export const content = defineMessages({
  ngeeannOne: {
    id: 'pages.about.ngeeann.one',
    defaultMessage:
      "Inaugurated in 1963, Ngee Ann Polytechnic is one of Singapore's leading institutions of higher education. Today, the polytechnic has a full-time enrolment of more than 14,800 students. The polytechnic offers 48 full-time courses through its nine academic schools.",
  },
  ngeeannTwo: {
    id: 'pages.about.ngeeann.two',
    defaultMessage:
      "With its emphasis on broad-based learning, global exposure and character development, Ngee Ann Polytechnic's vision is to prepare graduates with a passion for learning, values for life and competencies to thrive in a global workplace.",
  },
  sginnovateOne: {
    id: 'pages.about.sginnovate.one',
    defaultMessage:
      "At SGInnovate, we believe that Singapore has the resources & capabilities needed to tackle 'hard problems' that matter to people around the world.",
  },
  sginnovateTwo: {
    id: 'pages.about.sginnovate.two',
    defaultMessage:
      'As part of our Deep Tech Nexus Strategy, we are focused on adding tangible value to the Singapore deep tech startup ecosystem in two key areas - development of Human Capital and deployment of Investment Capital.',
  },
  sginnovateThree: {
    id: 'pages.about.sginnovate.three',
    defaultMessage:
      'Our efforts are also prioritised around identifying and building deep tech talents with world-class learning opportunities.',
  },
  indorseOne: {
    id: 'pages.about.indorse.one',
    defaultMessage:
      'Indorse is revolutionizing the way skills are validated. It provides a decentralized platform for candidates to receive skills assessment through an anonymous consensus of experienced professionals and experts.',
  },
});



// WEBPACK FOOTER //
// ./src/ui/pages/about-us/messages.js